import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CustomCopyIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="13.714"
        viewBox="0 0 13 13.714"
      >
        <path
          id="Caminho_10219"
          data-name="Caminho 10219"
          d="M8.571-2h-4.5a1.5,1.5,0,0,1-1.5-1.5v-7.929H.643A.643.643,0,0,0,0-10.786V-.929a.643.643,0,0,0,.643.643H7.929a.643.643,0,0,0,.643-.643Zm0-9.214V-14h-4.5a.643.643,0,0,0-.643.643V-3.5a.643.643,0,0,0,.643.643h7.286A.643.643,0,0,0,12-3.5v-7.071H9.214A.645.645,0,0,1,8.571-11.214Zm3.24-.831-1.766-1.766A.738.738,0,0,0,9.591-14H9.429v2.571H12v-.162A.739.739,0,0,0,11.812-12.045Z"
          transform="translate(0 14)"
          fill="#fb972e"
        />
        <path
          d="M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z"
          fill="#000"
          transform="translate(5 5) scale(0.5)"
        />
      </svg>
    </>
  );
}
